import { pluginButtons } from '../plugins';

export default {
  toolbarButtons: [
    'undo',
    'redo',
    '|',
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    // 'superscript',
    '|',
    pluginButtons.formatOL,
    pluginButtons.formatUL,
    'outdent',
    'indent',
    pluginButtons.insertTable,
    '|',
    pluginButtons.specialCharacters,
  ]
};
